export default __webpack_public_path__ + "static/media/fridge1-after2-1440w.bdf5f239.webp";